import { CoreType, GenericTableSchemaInterface, UserVars, StoreVars } from '../../swivl-lib'
import { BotVariables } from '@swivl/swivl-worksheets-lib'

export const FMSPlusPastDue00Table: GenericTableSchemaInterface = {
  id: 'fms-plus-past-due-00',
  name: 'FMS+ Past Due 00',
  description:
    'This table contains data regarding how many people were sent emails and texts messages via our FMS+ Payment Past Due workflows.',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'Operator Name',
      variable: BotVariables.Bot_Operator_Name
    },
    c02: {
      name: 'Facility ID',
      variable: StoreVars.StoreId
    },
    c03: {
      name: 'Tenant ID',
      variable: UserVars.User_TenantId
    },
    c04: {
      name: 'Account Balance',
      variable: UserVars.User_AccountBalance
    },
    c05: {
      name: 'Day that payment is due SMS'
    },
    c06: {
      name: '1 day after past due SMS'
    },
    c07: {
      name: '2 days after past due SMS'
    },
    c08: {
      name: '3 days after past due SMS'
    },
    c09: {
      name: '5 days after past due SMS'
    },
    c10: {
      name: '7 days after past due SMS'
    },
    c11: {
      name: '10 days after past due SMS'
    },
    c12: {
      name: '14 days after past due SMS'
    },
    c13: {
      name: '30 days after past due SMS'
    },
    c14: {
      name: '45 days after past due SMS'
    },
    c15: {
      name: 'Day that payment is due Email'
    },
    c16: {
      name: '1 day after past due Email'
    },
    c17: {
      name: '2 days after past due Email'
    },
    c18: {
      name: '3 days after past due Email'
    },
    c19: {
      name: '5 days after past due Email'
    },
    c20: {
      name: '7 days after past due Email'
    },
    c21: {
      name: '10 days after past due Email'
    },
    c22: {
      name: '14 days after past due Email'
    },
    c23: {
      name: '30 days after past due Email'
    },
    c24: {
      name: '45 days after past due Email'
    },
    c25: {
      name: 'SMS Link Clicked'
    }
  }
}
